import { useState, useEffect } from 'react'
import axios from 'axios'
import API from 'Common/Client/endpoint'

const userId = localStorage.getItem('personalId')
const role = localStorage.getItem('role')

const useFetchApiData = () => {
  const [members, setMembers] = useState([])
  const [groups, setGroups] = useState([])

  useEffect(() => {
    fetchUserData()
  }, [])

  useEffect(() => {
    if (role === 'Mentor') {
      fetchMentorData()
    }
  }, [role])

  const fetchUserData = async () => {
    try {
      const response = await axios.get(API.chats.addChat);
      const { role, users } = response.data

      if (!users || users.length === 0) {
        console.warn('No users found for this role')
        return
      }

      let singleChatData = []

      if (role === 'Admin' || role === 'Learner') {
        singleChatData = users.map((user) => ({
          id: user.userId,
          name: user.name,
        }))
      } else if (role === 'Mentor') {
        singleChatData = users.map((user) => ({
          id: user.userId,
          name: user.name,
        }))
      }

      setMembers(singleChatData)
    } catch (error) {
      console.error('Error fetching user data:', error)
    }
  }

  const fetchMentorData = async () => {
    try {
      const response = await axios.get(API.chats.getMentorGroupList(userId));

      const { role, groups } = response.data

      if (!groups || groups.length === 0) {
        console.warn('No groups found for this mentor')
        return
      }

      let groupChatData = []

      if (role === 'Mentor') {
        groupChatData = groups.map((group) => ({
          groupId: group.groupId,
          groupName: group.groupName,
        }))
      }

      setGroups(groupChatData)
    } catch (error) {
      console.error('Error fetching group data:', error)
    }
  }

  return { members, groups }
}

export default useFetchApiData
